import React from 'react'

import RightArrowIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'
import { IconButton } from 'src/Components/Buttons/IconButton'
import SettingsIcon from 'src/Assets/Svg/settings-outline.svg?react'
import BoltIcon from 'src/Assets/Svg/pages-icons/Bolt.svg?react'
import { SpotifyCampaignMatchingType } from 'src/Types/campaigns'

import {
  Container,
  Title,
  ItemsWrapper,
  ItemCard,
  ItemContent,
  TextWrapper,
  HeadlineWrapper,
  ItemTitle,
  ItemDescription,
  NewLabel,
} from './styled'

export interface CampaignTypeSelectorProps {
  onSelectType?: (type: SpotifyCampaignMatchingType) => void
}

export const CampaignTypeSelector: React.FC<CampaignTypeSelectorProps> = ({
  onSelectType,
}) => {
  const handleAutomatedClick = (): void => {
    onSelectType?.(SpotifyCampaignMatchingType.FEED)
  }

  const handleManualClick = (): void => {
    onSelectType?.(SpotifyCampaignMatchingType.MANUAL)
  }

  return (
    <Container>
      <Title>How you'd like to find curators for your track?</Title>
      <ItemsWrapper>
        <ItemCard onClick={handleAutomatedClick}>
          <ItemContent>
            <TextWrapper>
              <HeadlineWrapper>
                <BoltIcon />
                <ItemTitle>Automated</ItemTitle>
              </HeadlineWrapper>
              <ItemDescription>
                Pick curators for me - Our AI will automatically select the best
                curators for submission based on genres and language targeting.
              </ItemDescription>
            </TextWrapper>
          </ItemContent>
          <IconButton>
            <RightArrowIcon />
          </IconButton>
        </ItemCard>

        <ItemCard $isSelected onClick={handleManualClick}>
          <ItemContent>
            <TextWrapper>
              <HeadlineWrapper>
                <SettingsIcon />
                <ItemTitle>Manual</ItemTitle>
                <NewLabel>New</NewLabel>
              </HeadlineWrapper>
              <ItemDescription>
                I prefer to select curators myself - Browse and choose from our
                marketplace of verified curators.
              </ItemDescription>
            </TextWrapper>
          </ItemContent>
          <IconButton>
            <RightArrowIcon />
          </IconButton>
        </ItemCard>
      </ItemsWrapper>
    </Container>
  )
}
